module.exports = __webpack_public_path__ + "img/hepsiburada.5ead0426.png";